<template>
    <div class="scheme-create">
        
        <div class="page-title">
            <div class="title">搭配信息</div>
            
            <at-tour :show="showAtTour">
                <img id="cueWordBtn" src="/assets/images/deck/AI-create-btn.png" class="cursor-pointer"
                     @click="cueWordClick" alt="">
                <template slot="content">
                    <div class="tour-content">
                        <img src="/assets/images/scheme-info-tips.png" alt="">
                        <div class="tour-close-btn" @click="showAtTour = false">我知道了</div>
                    </div>
                </template>
            </at-tour>
        </div>
        
        
        <div class="scheme-info">
            <div class="info-left">
                
                <form-box label="搭配标题">
                    <a-input v-model="params.title" :maxLength="20" placeholder="请输入不超过20字的标题" type="text"/>
                    <div class="num">{{ params.title.length }}/20</div>
                </form-box>
                
                <form-box label="搭配说明">
                    <a-input v-model="params.summary" :maxLength="50" placeholder="请输入不超过50字的说明" type="text"/>
                    <div class="num">{{ params.summary.length }}/50</div>
                </form-box>
                
                <form-box label="适宜性别">
                    <div :class="params.gender == 2 ? 'gender active' : 'gender'" @click="params.gender = 2">
                        <img src="/assets/images/deck/info-active-nv.png" v-if="params.gender == 2">
                        <img src="/assets/images/deck/info-nv.png" v-else>
                        <span>女士</span>
                    </div>
                    <div :class="params.gender == 1 ? 'gender active' : 'gender'" @click="params.gender = 1">
                        <img src="/assets/images/deck/info-active-nan.png" v-if="params.gender == 1">
                        <img src="/assets/images/deck/info-nan.png" v-else>
                        <span>男士</span>
                    </div>
                </form-box>
                
                <style-box :label="item.label" v-for="item in list" :key="item.label">
                    <div class="list">
                        <div class="item" v-for="child in item.list" :key="child.id" @click="styleChange(child)">
                            <div class="bg">
                                <img :src="child.thumb">
                                <img class="active" src="/assets/images/deck/style-select.png" v-if="child.active">
                            </div>
                            <div class="name">{{ child.name.split('style')[0] }}</div>
                        </div>
                    </div>
                </style-box>
                
                <div class="btn-box">
                    <div class="cancel cursor" @click="back()">取消</div>
                    <div class="submit cursor" @click="submitScheme()">提交</div>
                </div>
            </div>
            
            <div class="info-right">
                <div>
                    <div class="scheme-img">
                        <img :src="image">
                    </div>
                    <div class="scheme-label">搭配缩略图</div>
                </div>
                <div class="goods-images-box">
                    <div class="goods-images-up" v-if="showListArrow"></div>
                    <perfect-scrollbar ref="goodsScrollbar" class="goods-images-scroll">
                        <div class="goods-images-list">
                            <div class="goods-images-item" v-for="item in usedGoods" :key="item.id">
                                <img :src="item.white_image || item.thumb_image || item.thumb ">
                            </div>
                        </div>
                    </perfect-scrollbar>
                    <div class="goods-images-down" v-if="showListArrow"></div>
                </div>
            </div>
        
        </div>
        
        <scheme-qrcode :type="schemeType" :scheme-id="detailId" v-model="showDetailQrcode"></scheme-qrcode>
        
        <cue-word-loading ref="cueWordLoading"></cue-word-loading>
    
    </div>

</template>

<script>
import api from "@/repo/api";
import FormBox from '../Com/FormBox.vue';
import StyleBox from "../Com/StyleBox.vue";
import SchemeQrcode from "@/components/SchemeQrcode";
import CueWordLoading from "@/components/CueWordLoading.vue";
import AtTour from "@/components/AtTour.vue";

export default {
    components: {AtTour, FormBox, StyleBox, SchemeQrcode, CueWordLoading},
    data() {
        return {
            hideMenu: true,
            showDetailQrcode: false,
            detailId: 0,
            image: '',
            schemeType: 'shop',
            list1: [],
            list2: [],
            list3: [],
            list4: [],
            params: {
                title: '',
                summary: '',
                gender: 2,
            },
            scrollPosition: 0,
            usedGoods: null,
            openGuide: true,
            showAtTour: false,
        }
    },
    computed: {
        showListArrow() {
            return this.usedGoods && this.usedGoods.length > 5
        },
        list() {
            let arr1 = [];
            let arr2 = [];
            let arr3 = [];
            let arr4 = [];
            
            this.list1.forEach((item) => {
                if (item.gender == this.params.gender) {
                    arr1.push(item);
                }
            })
            
            this.list2.forEach((item) => {
                if (item.gender == this.params.gender || item.gender == 0) {
                    if (this.params.gender == 1) {
                        item.thumb = item.extra.thumb || item.extra.man_thumb;
                    } else {
                        item.thumb = item.extra.thumb || item.extra.woman_thumb;
                    }
                    arr2.push(item);
                }
            })
            
            this.list3.forEach((item) => {
                if (item.gender == this.params.gender || item.gender == 0) {
                    if (this.params.gender == 1) {
                        item.thumb = item.extra.thumb || item.extra.man_thumb;
                    } else {
                        item.thumb = item.extra.thumb || item.extra.woman_thumb;
                    }
                    arr3.push(item);
                }
            })
            
            this.list4.forEach((item) => {
                if (item.gender == this.params.gender || item.gender == 0) {
                    if (this.params.gender == 1) {
                        item.thumb = item.extra.thumb || item.extra.man_thumb;
                    } else {
                        item.thumb = item.extra.thumb || item.extra.woman_thumb;
                    }
                    arr4.push(item);
                }
            })
            
            return [
                {
                    label: '搭配风格',
                    list: arr1,
                },
                {
                    label: '风格氛围感',
                    list: arr2,
                },
                {
                    label: '适合场合',
                    list: arr3,
                },
                {
                    label: '适合季节',
                    list: arr4,
                },
            ]
        },
        styles() {
            let ids = [];
            this.list[0].list.forEach((item) => {
                if (item.active) {
                    ids.push(item.id);
                }
            })
            return ids;
        },
        atmosphere() {
            let ids = [];
            this.list[1].list.forEach((item) => {
                if (item.active) {
                    ids.push(item.id);
                }
            })
            return ids;
        },
        occasion() {
            let ids = [];
            this.list[2].list.forEach((item) => {
                if (item.active) {
                    ids.push(item.id);
                }
            })
            return ids;
        },
        season() {
            let ids = [];
            this.list[3].list.forEach((item) => {
                if (item.active) {
                    ids.push(item.id);
                }
            })
            return ids;
        },
    },
    mounted() {
        
        this.showAtTour = !localStorage.getItem('_scheme_show_info_tour');
        
        localStorage.setItem('_scheme_show_info_tour', '1');
        
        let query = JSON.parse(localStorage.getItem('_scheme_build_data'));
        
        if (query.id) {
            this.getDetail(query.id);
        }
        
        this.image = localStorage.getItem('_scheme_build_image');
        this.usedGoods = JSON.parse(localStorage.getItem('_scheme_used_goods'));
        
        this.getAttributes();
    },
    methods: {
        cueWordClick() {
            this.$refs.cueWordLoading.show();
            const image = localStorage.getItem('_scheme_build_image');
            api.post('/ast-ai/scheme-detail-parse', {image, image_type: 'base64'}, (res) => {
                if (res.code == 0) {
                    
                    let title = res.data['搭配名称'];
                    if (title) {
                        this.params.title = title;
                    }
                    
                    let summary = res.data['搭配说明'];
                    if (summary) {
                        this.params.summary = summary;
                    }
                    
                    // 适合性别: "男"去数据里匹配，有则添加
                    let gender = res.data['适合性别'];
                    if (gender == '男') {
                        this.params.gender = 1;
                    } else if (gender == '女') {
                        this.params.gender = 2;
                    }
                    
                    // 适合风格人群: ["浪漫妩媚", "甜酷风格", "简约知性"],去数据里匹配，有则添加
                    let style = res.data['适合风格人群'];
                    if (style) {
                        style.forEach((item) => {
                            if (this.list[0].list.find((key) => key.name == item)) {
                                this.$set(this.list[0].list.find((key) => key.name == item), 'active', true);
                            }
                        })
                    }
                    
                    // 搭配氛围类型: ["简约", "温柔", "精致"]，去数据里匹配，有则添加
                    let atmosphere = res.data['搭配氛围类型'];
                    if (atmosphere) {
                        atmosphere.forEach((item) => {
                            if (this.list[1].list.find((key) => key.name == item)) {
                                this.$set(this.list[1].list.find((key) => key.name == item), 'active', true);
                            }
                        })
                    }
                    
                    // 搭配氛围类型: ["简约", "温柔", "精致"]，去数据里匹配，有则添加
                    let occasion = res.data['适合场合穿着'];
                    if (occasion) {
                        occasion.forEach((item) => {
                            if (this.list[2].list.find((key) => key.name == item)) {
                                this.$set(this.list[2].list.find((key) => key.name == item), 'active', true);
                            }
                        })
                    }
                    
                    // 适合季节: ["夏季", "秋季", "冬季", "春季"]，去数据里匹配，有则添加
                    let season = res.data['适合季节'];
                    if (season) {
                        season.forEach((item) => {
                            item = item.replace('季', '');
                            if (this.list[3].list.find((key) => key.name == item)) {
                                this.$set(this.list[3].list.find((key) => key.name == item), 'active', true);
                            }
                        })
                    }
                    
                    this.$refs.cueWordLoading.hide();
                }
            })
        },
        back() {
            this.$router.back();
        },
        getDetail(id) {
            api.get('/ast-scheme/scheme-detail', {id}, (res) => {
                if (res.code == 0) {
                    this.params.title = res.data.title;
                    this.params.summary = res.data.summary;
                    this.params.gender = res.data.gender;
                    this.setStyle(res.data.styles, 0);
                    this.setStyle(res.data.atmosphere, 1);
                    this.setStyle(res.data.occasion, 2);
                    this.setStyle(res.data.season, 3);
                }
            })
        },
        setStyle(list, idx) {
            if (this.list[idx].list.length) {
                console.log(this.list[idx]);
                list.forEach((item) => {
                    this.list[idx].list.forEach((key) => {
                        if (item.id == key.id) {
                            this.$set(key, 'active', true);
                        }
                    })
                })
            } else {
                setTimeout(() => {
                    this.setStyle(list, idx);
                }, 200);
            }
        },
        submitScheme() {
            
            if (!this.params.title) {
                return this.showError('搭配标题不能为空');
            }
            
            if (!this.params.summary) {
                return this.showError('搭配说明不能为空');
            }
            
            if (!this.params.gender) {
                return this.showError('请选择适宜性别');
            }
            
            if (!this.styles.length) {
                return this.showError('请选择适宜风格');
            }
            
            if (!this.atmosphere.length) {
                return this.showError('请选择适宜氛围');
            }
            
            if (!this.occasion.length) {
                return this.showError('请选择适宜场景');
            }
            
            if (!this.season.length) {
                return this.showError('请选择适宜季节');
            }
            
            let query = JSON.parse(localStorage.getItem('_scheme_build_data'));
            
            let params = this.params;
            params.styles = this.styles;
            params.atmosphere = this.atmosphere;
            params.occasion = this.occasion;
            params.season = this.season;
            
            params.image = localStorage.getItem('_scheme_build_image');
            params.frame = query.frame;
            params.goods = query.goods;
            
            if (query.id) {
                params.id = query.id;
            }
            
            console.log(params);
            
            this.deckSave(params);
        },
        
        deckSave(data) {
            
            this.$swal.fire({
                title: '提交中，请稍候...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
            })
            
            api.post('/ast-scheme/sync-scheme', data, (result) => {
                
                this.$swal.close();
                
                if (result.code !== 0) {
                    localStorage.removeItem('image');
                    this.$swal({
                        title: result.msg,
                        icon: 'error',
                        confirmButtonText: '好'
                    });
                    
                    return
                }
                this.$router.push(`/ast/shop/scheme/show`)
            })
        },
        styleChange(item) {
            this.$set(item, 'active', !item.active);
        },
        getAttributes() {
            api.get('/ast-scheme/attributes', (data) => {
                
                if (!data.data) return;
                
                this.filterStyle(data.data.attributes);
            })
        },
        filterStyle(list) {
            // 风格
            let list1 = [];
            // 氛围
            let list2 = [];
            // 场合
            let list3 = [];
            // 季节
            let list4 = [];
            
            list.forEach((item) => {
                if (item.parent_id == 10086) {
                    list1.push(item);
                }
                if (item.parent_id == 8) {
                    list2.push(item);
                }
                if (item.parent_id == 5) {
                    list3.push(item);
                }
                if (item.parent_id == 7) {
                    list4.push(item);
                }
            })
            
            this.list1 = list1;
            this.list2 = list2;
            this.list3 = list3;
            this.list4 = list4;
        },
        showError(msg) {
            this.$swal({
                title: msg,
                icon: 'error',
                confirmButtonText: '好'
            });
        },
    }
}
</script>

<style lang="less" scoped>

.page-title {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
    
    .title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
    }
    
    img {
        width: 93px;
        height: 20px;
        margin-left: 8px;
    }
}

.scheme-info {
    display: flex;
    
    .info-right {
        .scheme-img {
            width: 248px;
            height: 248px;
            background: #F5F5F5;
            padding: 8px;
            
            img {
                width: 100%;
                height: 100%;
            }
        }
        
        .scheme-label {
            width: 248px;
            text-align: center;
            line-height: 24px;
            color: rgba(51, 51, 51, 0.8);
            margin-top: 16px;
        }
    }
    
    .info-left {
        width: 840px;
        margin-right: 40px;
        
        .list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            
            .item {
                width: fit-content;
                margin-right: 16px;
                margin-bottom: 16px;
                
                .bg {
                    position: relative;
                    
                    img {
                        width: 68px;
                        height: 68px;
                        border-radius: 50%;
                    }
                    
                    .active {
                        width: 68px;
                        height: 68px;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }
                
                .name {
                    color: #333333;
                    font-size: 16px;
                    text-align: center;
                    margin-top: 12px;
                }
            }
        }
        
        .btn-box {
            display: flex;
            align-items: center;
            margin-bottom: 32px;
            
            div {
                width: 92px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 14px;
                cursor: pointer;
            }
            
            .cancel {
                color: #F5606D;
                border: 1px solid #F5606D;
                margin-right: 16px;
            }
            
            .submit {
                color: #FFFFFF;
                background: #333333;
            }
        }
        
        input {
            width: 90%;
            resize: none;
            border: none;
            outline: none;
            box-shadow: none;
            color: #333333;
        }
        
        .num {
            color: rgba(0, 0, 0, 0.25);
            font-size: 14px;
        }
        
        .gender {
            width: 72px;
            height: 40px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            color: #333333;
            background: #F7F7F7;
            cursor: pointer;
            
            img {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }
        }
        
        .active {
            color: #FFFFFF;
            background: #333333;
        }
    }
}

.goods-images-box {
    margin-top: 24px;
}

.goods-images-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.goods-images-item {
    width: 248px;
    height: 248px;
    border: 1px solid #E6E6E6;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.goods-images-up, .goods-images-down {
    width: 248px;
    height: 43px;
    background: #F7F7F7;
    position: relative;
}

.goods-images-up {
    border-radius: 4px 4px 0 0;
    margin-bottom: 16px;
}

.goods-images-down {
    border-radius: 0 0 4px 4px;
    margin-top: 16px;
}

/* 正三角形 - 12px高，24px底边 */
.goods-images-up::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent; /* 底边的一半 */
    border-right: 12px solid transparent; /* 底边的一半 */
    border-bottom: 12px solid rgb(51, 51, 51); /* 高度 */
}

/* 倒三角形 - 12px高，24px底边 */
.goods-images-down::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent; /* 底边的一半 */
    border-right: 12px solid transparent; /* 底边的一半 */
    border-top: 12px solid rgb(51, 51, 51); /* 高度 */
}

.goods-images-scroll {
    height: 1220px;
}

.tour-content {
    padding-top: 15px;
    padding-left: 84px;
    
    img {
        height: 116px;
        width: 206px;
    }
    
    .tour-close-btn {
        width: 88px;
        height: 32px;
        background: linear-gradient(180deg, #01C9BF 0%, #01B8DB 100%);
        box-shadow: 2px 4px 4px 0px rgba(37, 255, 245, 0.2);
        border-radius: 8px 8px 8px 8px;
        font-weight: normal;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 32px;
        text-align: center;
        margin-top: 12px;
        cursor: pointer;
    }
}

</style>